module.exports = __webpack_public_path__ + "img/more.9867e7ee.svg";